module.exports = __webpack_public_path__ + "img/APP.3af16afd.png";